export const CONFIG = {
  email: 'gavinaantonacci@gmail.com',

  social: {
    linkedin: 'https://www.linkedin.com/in/gavin-antonacci-6b4b342a9/',
    github: 'https://github.com/imhubgitting',
  },

  files: {
    cv: '/assets/resume_gavin_antonacci_2026_v1.pdf',
    resume: '/assets/resume_gavin_antonacci_2026_v1.pdf',
  },

  theme: {
    storageKey: 'theme',
    default: 'light',
  },

  ui: {
    toastDuration: 2000,
    prefetchDelay: 65,
    animationDuration: 300,
  },
};
